import React, { useRef } from "react";
import { useLocation } from "react-router-dom";

// Content wrapper. The shell lives in AppShell and never reloads; only this
// content area cross-fades and slides 8px when the route changes. Direction:
// going deeper slides from the right, going back slides from the left.
let lastDepth = window.history.state?.idx ?? 0;

export default function Layout({ children }) {
  const location = useLocation();
  const depth = window.history.state?.idx ?? 0;
  const back = depth < lastDepth;
  lastDepth = depth;
  const cls = back ? "page-enter-back" : "page-enter-fwd";
  return (
    <div key={location.pathname} className={`page-content ${cls}`}>
      {children}
    </div>
  );
}
